import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {delApplicationMenu} from '@store/actions/menuAction';
import { showModal } from '@store/actions/commonAction';

const MenuEditBottom  = props => {
    const dispatch = useDispatch();
    const {
        visible,        
        saveBtn,
        cancelBtn,
        handleDelCallcakfunc
    } = props;

    //삭제처리
    const delBtn = () => {        
        
        dispatch(
            showModal({
                visible: true,
                type: 'confirm',
                msg: '삭제하겠습니까?',
                onOk: { label: '예', handle: () => dispatch(delApplicationMenu({callback: handleDelCallcakfunc})) },
                onCancel: { label: '아니요' },
            })
        );

    }

return (visible && (
        <div className="btn-area-jb">
            <div className="btn-area-l">
                <button className="btn-m del" onClick={() => delBtn()}>삭제</button>
            </div>
            <ul className="file-list">
                <li>
                    <button className="btn-m cancel" onClick={() => cancelBtn()}>취소</button>
                </li>
                <li>
                    <button className="btn-m save" onClick={() => saveBtn()}>저장</button>
                </li>
            </ul>
        </div>
        )
    );
};


export default MenuEditBottom;